import { Chip } from '@mui/material'
import { applicationStatuses } from 'pages/Applications/applicationStatuses'

export const StatusChip = ({ status }: { status: number }) => {
  const applicationStatusColor = applicationStatuses[status].color

  return (
    <Chip
      variant="outlined"
      size="small"
      color={applicationStatusColor}
      sx={{ fontWeight: 600, textTransform: 'capitalize' }}
      label={applicationStatuses[status].value ?? 'N/A'}
    />
  )
}
